import { useTranslation } from "react-i18next";
import styled from "styled-components"

const Placeholder = styled.span`
    display: inline-block;
    width: 100%;
    height: 20px;
    ${props => props.style ? 'background-color: #ccc;' : 'background-image: url("/img/blurrytext.png");'}
    background-size: contain;
    background-repeat: no-repeat;
    border-radius: 5px;
    position: relative;

    &::before {
        content: "${props => props.tooltipText}";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 10px);
        background-color: #000;
        color: #fff;
        padding: 5px;
        border-radius: 5px;
        font-size: 12px;
        display: none;
        z-index: 2;
    }

    &:hover::before {
        display: block;
    }
`

const NoAccessPlaceholder = (props) => {

    const { i18n } = useTranslation('common');

    const tooltipText = i18n.language === "fr" ? "Vous devez être membre de la communauté pour accéder à cette infromation." : "You must be a member of the community to access this information."

    return (
        <Placeholder style={props.style} tooltipText={tooltipText}/>
    )
}

export default NoAccessPlaceholder;